import React from 'react'
import { Head } from '../../component'
import { AdjustAmount } from './components'
import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutPage } from '../../model'
import { useTranslation } from '../../utils/convergence'

export const AdjustAmountPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const pageTitle = t('common:brandName')

  return (
    <>
      <Head title={pageTitle} />
      <AdjustAmount />
      <TrackPageViewed />
    </>
  )
}
